export default __webpack_public_path__ + "static/media/tote-hd-600.1df45df4.jpg";